<template>
  <main-layout>
	<section role="main" aria-label="תוכן" class="content" id="RhythmAudition">
			<div class="divider"></div>
			<div class="info-content">
				<div class="fill">
					<img :key=img2srcD src="photos/ensemble/aa1.jpg" alt="רישום לאנסמבל" class="fillImgFront" >
				</div>
				<div class="textbox-bounds textbox-bounds-unbound-double">
					<div class="textbox textbox-right">
						<div class="textbox-tab-mark""></div>
						<div class="textbox-text">
							<div class="auditionLogo">
								<img src="images/logo.png" alt="החצר" class="fillImg" >
								<div class="auditionLogoSubtitle">אנסמבל קולי</div>
							</div>
							<div class="text-box-paragraph">
								<h3 v-html="texts.ensamble_text1header"></h3>
								<p v-html="texts.ensamble_text1"></p>
							</div>
							<div class="text-box-paragraph">
								<h3 v-html="texts.ensamble_text2header"></h3>
								<p v-html="texts.ensamble_text2"></p>
							</div>
							<div class="text-box-paragraph">
								<h3 v-html="texts.ensamble_text3header"></h3>
								<p v-html="texts.ensamble_text3"></p>
							</div>

							<div class="text-box-paragraph">

								<div class="talkWithUs" v-on:click="showDialog = true">רוצים לדבר איתנו?</div>
							</div>
						</div>
					</div>
					<div class="textbox textbox-right textbox-bounds-unbound-double">

						<div class="textbox-text">
							<Audition auditionType="Ensemble"></Audition>
						</div>
					</div>
				</div>
			</div>
			<br>
			<div id="FAQSdivider" class="divider"></div>
			<div id="FAQS" class="info-content double-content2">
				<div class="fill double-content2">
					<img :key=img2srcD src="photos/ensemble/aa2.jpg" alt="שאלות נפוצות" class="fillImgFront" >
				</div>
				<div class="textbox-bounds double-textbounds">
				<div class="textbox textbox-right">
					<div class="textbox-tab-mark"></div>
					<div class="textbox-text">
						<div class="text-box-paragraph">
							<h3>שאלות נפוצות</h3>
							<transition name="fade" mode="out-in">
								<FAQ :key="faq"></FAQ>
							</transition>
						</div>
					</div>
				</div>
			</div>
		</div>

		<TalkToMe auditionType='Ensemble' v-if="showDialog" @close="showDialog = false"></TalkToMe>
		</section>
  </main-layout>
</template>

<script>
var APIbase = "https://yard-bands.herokuapp.com"
import axios from 'axios'
  import MainLayout from '../layouts/Main.vue'
   import VLink from '../components/VLink.vue'
  import FAQ from '../components/FAQ.vue'
  import Audition from '../components/Audition.vue'
  import TalkToMe from '../components/TalkToMe.vue'
  import VueScrollTo from 'vue-scrollto'
  export default {
    components: {
      MainLayout,FAQ,VLink,Audition,TalkToMe
    },
	created () {
    window.viewingEnsemble = true;
		this.texts = {}
		this.fetchEnsembleLabels();
	},
  destroyed() {
    window.viewingEnsemble = false;
  },
	ready:function(){
		window.pageLoaded();

		
    },
	data() {
		return {
			showDialog : false
		}
	},
	watch: {
		showDialog: function (val) {
			if (val) {
				document.body.classList.add('modal-open');
				document.getElementById("headerC").classList.add('background-modal');
				document.getElementById("content-wrapper").classList.add('background-modal-wrapper');
        document.getElementById("FAQSdivider").classList.add('background-modal');
        document.getElementById("FAQS").classList.add('background-modal');
        document.getElementById("footerC").classList.remove('background-modal');
			}
			else {
				document.body.classList.remove('modal-open');
				document.getElementById("headerC").classList.remove('background-modal');
        document.getElementById("content-wrapper").classList.remove('background-modal-wrapper');
        document.getElementById("FAQSdivider").classList.remove('background-modal');
        document.getElementById("FAQS").classList.remove('background-modal');
        document.getElementById("footerC").classList.remove('background-modal');
			}
		}
	},
	methods: {
		fetchEnsembleLabels() {
			axios.get(APIbase+'/ensamble_text').then(response => {
				this.texts = response.data;
				this.$forceUpdate();
			})
		}
	}

  }
</script>



// WEBPACK FOOTER //
// Ensemble.vue?f8b447de